import { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';

interface ScrollInterface {
  scrollsTop: boolean;
  scrollsBottom: boolean;
}

export function useScroll(): ScrollInterface {
  const { pathname } = useLocation();

  const [scrollsTop, setScrollsTop] = useState(false);
  const [scrollsBottom, setScrollsBottom] = useState(false);

  useEffect(() => {
    handleScroll();

    window.addEventListener('resize', handleScroll);
    window.addEventListener('scroll', handleScroll);

    const resizeObserver = new ResizeObserver(handleScroll);
    resizeObserver.observe(document.body);

    return () => {
      window.removeEventListener('resize', handleScroll);
      window.removeEventListener('scroll', handleScroll);
      resizeObserver.disconnect();
    };
  }, []);

  useEffect(() => {
    handleScroll();
  }, [pathname]);

  function handleScroll() {
    setScrollsTop(window.scrollY > 0);

    const { scrollTop, scrollHeight, clientHeight } = document.documentElement;
    setScrollsBottom(scrollTop + clientHeight < scrollHeight - 1);
  }

  return useMemo(
    () => ({
      scrollsTop,
      scrollsBottom,
    }),
    [scrollsTop, scrollsBottom],
  );
}
